function getPreloadRequests(data) {
  return (data?.sections || []).reduce((requests, section) => {
    if (section?.name !== "preload") {
      return requests;
    }

    if (Array.isArray(section.requests)) {
      return requests.concat(section.requests);
    }

    if (Array.isArray(section.apis)) {
      return requests.concat(section.apis);
    }

    if (section.api && typeof section.api === "object") {
      return requests.concat(section.api);
    }

    if (section.url || section.uri) {
      return requests.concat(section);
    }

    return requests;
  }, []);
}

function resolveUrlParameters(url, parameters) {
  return Object.entries(parameters).reduce(
    (resolvedUrl, [name, value]) =>
      resolvedUrl
        .replaceAll(`{${name}}`, encodeURIComponent(value))
        .replaceAll(`:${name}`, encodeURIComponent(value)),
    url
  );
}

function createPreloadRequestOptions(request) {
  const method = String(request.method || "GET").toUpperCase();
  const headers =
    request.headers && typeof request.headers === "object"
      ? request.headers
      : {};

  const options = {
    method,
    headers,
  };

  if (request.credentials) {
    options.credentials = request.credentials;
  }

  if (request.mode) {
    options.mode = request.mode;
  }

  if (
    method !== "GET" &&
    method !== "HEAD" &&
    request.body !== undefined
  ) {
    options.headers = {
      "Content-Type": "application/json",
      ...headers,
    };
    options.body = JSON.stringify(request.body);
  }

  return options;
}

async function parsePreloadResponse(response) {
  const contentType = response.headers.get("content-type") || "";

  if (contentType.includes("application/json")) {
    return response.json();
  }

  return response.text();
}

export async function executePreloads(data, context = {}) {
  const requests = getPreloadRequests(data);

  const results = await Promise.all(
    requests.map(async (request, index) => {
      const key = request.key || request.name || `request_${index + 1}`;
      const urlTemplate = String(request.url || request.uri || "").trim();

      if (!urlTemplate) {
        return {
          key,
          ok: false,
          error: "Preload request URL is missing.",
        };
      }

      try {
        const url = resolveUrlParameters(urlTemplate, context);
        const response = await fetch(url, createPreloadRequestOptions(request));
        const data = await parsePreloadResponse(response);

        return {
          key,
          ok: response.ok,
          status: response.status,
          data,
        };
      } catch (error) {
        return {
          key,
          ok: false,
          error: error.message,
        };
      }
    })
  );

  return {
    list: results,
    byKey: results.reduce((items, result) => {
      items[result.key] = result;
      return items;
    }, {}),
  };
}

export function hasCompletedWebinarPreload(preloads) {
  return (preloads?.list || []).some((result) => {
    const data = result?.data;
    const webinar = data?.webinar || data;

    return (
      webinar?.isCompleted === true ||
      webinar?.status === "completed" ||
      webinar?.completed === true
    );
  });
}
